import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import FormTextField from '../form/redux-form/FormTextField';
import FormCheckBox from '../form/redux-form/FormCheckBox';
import PricingDetailsForm from '../pricing/PricingDetailsForm';
import { Typography, Paper } from '@material-ui/core';
import FormSelect from '../form/redux-form/FormSelect';
import { PlanValidityTypes } from '../../models/plans/PlanModel';
import { planFormValidation } from '../../models/plans/PlanValidation';

const bikeTypeValues = bikeTypes => ({
  all: { value: null, name: 'Wszystkie typy rowerów' },
  ...bikeTypes.map(bikeType => ({ value: bikeType.id, name: bikeType.name })),
});

const PlanDetailsForm = ({ onSubmit, initialValues, readonly, bikeTypes }) => (
  <PricingDetailsForm
    onSubmit={data => onSubmit(data)}
    fieldPrefix="pricingConfiguration."
    isPlan
    initialValues={initialValues}
    validate={planFormValidation}
    readonly={readonly}
  >
    <Typography variant="subtitle1" gutterBottom>Plan</Typography>
    <Paper className="config-section" elevation={3}>
      <div>
        <Field
          name="name"
          component={FormTextField}
          readonly={readonly}
          label="Nazwa"
          autoFocus
        />
      </div>
      <div>
        <Field
          name="description"
          component={FormTextField}
          readonly={readonly}
          label="Opis"
          fullWidth
        />
      </div>
      <div>
        <Field
          name="price"
          type="number"
          component={FormTextField}
          readonly={readonly}
          label="Cena"
          endAdornmentText="zł"
        />
      </div>
      <div>
        <Field
          name="validity"
          component={FormSelect}
          readonly={readonly}
          label="Okres ważności"
          style={{ width: 200 }}
          values={PlanValidityTypes}
        />
      </div>
      <div>
        <Field
          name="bikeTypeId"
          component={FormSelect}
          readonly={readonly}
          label="Typ roweru"
          style={{ width: 260 }}
          values={bikeTypeValues(bikeTypes)}
        />
      </div>
      <div>
        <Field
          name="excludeInactiveMonths"
          component={FormCheckBox}
          readonly={readonly}
          label="Nie wliczaj miesięcy nieaktywnych (listopad-luty)"
        />
      </div>
      <div>
        <Field
          name="internalUseOnly"
          component={FormCheckBox}
          readonly={readonly}
          label="Plan testowy"
        />
        <Typography display="block" variant="caption">
          Wybierz, jeśli chcesz, aby plan był dostępny tylko testerów
        </Typography>
      </div>
      <div>
        <Field
          name="dedicated"
          component={FormCheckBox}
          readonly={readonly}
          label="Plan dedykowany"
        />
      </div>
      <div>
        <Field
          name="voucherOnly"
          component={FormCheckBox}
          readonly={readonly}
          label="Plan voucherowy"
        />
        <Typography display="block" variant="caption">
          Plan dostępny tylko przez voucher, niewidoczny w standardowej sprzedaży
        </Typography>
      </div>
    </Paper>
  </PricingDetailsForm>
);

PlanDetailsForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.object.isRequired,
  readonly: PropTypes.bool,
  bikeTypes: PropTypes.array.isRequired,
};

PlanDetailsForm.defaultProps = {
  readonly: false,
};

function mapStateToProps(state) {
  return {
    bikeTypes: state.bikeTypes.list,
  };
}

export default connect(mapStateToProps)(PlanDetailsForm);
